/* eslint-disable jsx-a11y/no-autofocus */
import "./signin.scss";
import "./signup.scss";
import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import PopoverWithArrow from "../../components/ui/PopoverWithArrow";
import { HelpOutline } from "@mui/icons-material";
import BackdropProgressBar from "../../components/ui/BackdropProgressBar";
import ClearIcon from "@mui/icons-material/Clear";
import {
  EnterpriseUserDto,
  UserDto,
  SignUpAuthModeSettingsDto,
  PortalIssueTypeDto,
  PortalRequestFormDetailsDto,
  UserResponseDto,
} from "../../types/User";
import {
  Paper,
  Snackbar,
  Alert,
  Divider,
  Select,
  MenuItem,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Popper,
  InputAdornment,
  InputLabel,
  Tooltip,
  DialogTitle,
} from "@mui/material";
import {
  createUser,
  checkUsernameExist,
  checkEmailOrPhoneExist,
  userExist,
  sendHelpDeskRequestForm,
} from "../../services/userService";
import useApi from "../../hooks/useApi";
import {
  SIGNUPMODE,
  REGEX,
  USERINFO,
  OTPMODE,
  COMMONCONSTANTS,
  COOKIESNAME,
  VERIFICATIONTYPE,
} from "../../data/constants";
import SignUpWithPassword, { SignUpWithPasswordRef } from "../signup/SignUpWithPassword";
import SignUpWithOTP from "../signup/SignUpWithOTP";
import SignUpWithTwoFactorAuth from "../signup/SignUpWithTwoFactorAuth";
import { POPOVERMESSAGES, USERSIGNINMESSAGES, USERSIGNUPMESSAGES } from "../../constants/messages";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from "js-cookie";
import EmployeeCheck from "../contacts/EmployeeCheck";
interface SignUpProps {
  disableCustomTheme?: boolean;
  onTabClick?: (tabName: number) => void;
  onIsSessionLocked: () => void;
  authModeSettings: SignUpAuthModeSettingsDto;
  issueType: PortalIssueTypeDto[];
}

export default function SignUp(props: SignUpProps) {
  const [authMode, setAuthMode] = useState({
    password: false,
    otp: false,
    authApp: false,
    passwordOrOTP: false,
    passwordOrAuthApp: false,
    passwordAndOTP: false,
    passwordAndAuthApp: false,
  });
  const [userDetails, setUserDetails] = useState({
    emailOrPhone: "",
    userName: "",
    userFirstName: "",
    userLastName: "",
    userEmail: "",
    userEmail2: "",
    userPhone: "",
    userCellPhone: "",
    password: "",
    confirmPassword: "",
    entityId: 0,
    userModuleName: "",
    cachedEmailAddress: "",
    cachedCellPhone: "",
    emailSource: "",
  });
  const [helpdeskrequestformDetails, sethelpdeskrequestformDetails] = useState({
    emailOrPhone: "",
    userName: "",
    userFirstName: "",
    userLastName: "",
    userEmail: "",
    issueType: "",
    additionalDetails: "",
  });
  const [errors, setErrors] = useState({
    emailOrPhoneError: false,
    emailOrPhoneErrorMessage: "",
    userNameError: false,
    userNameErrorMessage: "",
    validationMessage: "",
    requestFormFirstNameError: false,
    requestFormFirstNameErrorMessage: "",
    requestFormLastNameError: false,
    requestFormLastNameErrorMessage: "",
    requestFormemailOrPhoneError: false,
    requestFormemailOrPhoneErrorMessage: "",
    requestFormIssueTypeError: false,
    requestFormIssueTypeErrorMessage: "",
    requestFormAdditionalDetailsError: false,
    requestFormAdditionalDetailsErrorMessage: "",
  });

  const [authState, setAuthState] = useState({
    isOtpVerificationRequired: false,
    is2faAuthRequired: false,
    isVerificationCodeVerified: false,
    token: "",
    otpSendTo: "",
    secretKey: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [isSessionLocked, setIsSessionLocked] = useState(false);
  const { loading, executeApi } = useApi();
  const [skipLoading, setSkipLoading] = useState(false);
  const childRef = useRef<SignUpWithPasswordRef>(null);
  // const passwordRef = useRef<SignUpWithPasswordRef>(null);
  const emailOrPhoneRef = useRef<HTMLInputElement>(null);
  const userNameRef = useRef<HTMLInputElement>(null);
  // Sequence number of the newest Email/Phone check. Each blur bumps it, so a
  // response that arrives after the field changed can be discarded instead of
  // overwriting the current message.
  const emailCheckSeqRef = useRef<number>(0);
  const emailCheckTimerRef = useRef<ReturnType<typeof setTimeout>>();
  const [requestFormSnackbarOpen, setrequestFormSnackbarOpen] = useState<boolean>(false);
  const [emailLoading, setEmailLoading] = useState<boolean>(false);
  const [userNameLoading, setUserNameLoading] = useState<boolean>(false);
  const [state, setState] = useState({
    issueTypeOptions: [] as PortalIssueTypeDto[],
  });
  const RequestFormFirstNameRef = useRef<HTMLInputElement>(null);
  const RequestFormLastNameRef = useRef<HTMLInputElement>(null);
  const additionalDetailsRef = useRef<HTMLInputElement>(null);

  const updateState = <T extends Record<string, unknown>>(
    setState: React.Dispatch<React.SetStateAction<T>>,
  ) => {
    return (newState: Partial<T>) => {
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
    };
  };

  const updateValue = (newState: Partial<typeof state>) => {
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  const updateAuthModeState = updateState<typeof authMode>(setAuthMode);
  const updateUserDetailsState = updateState<typeof userDetails>(setUserDetails);
  const updateErrorsState = updateState<typeof errors>(setErrors);
  const updateAuthStateState = updateState<typeof authState>(setAuthState);
  const updateRequestFormDetailsState = updateState<typeof helpdeskrequestformDetails>(
    sethelpdeskrequestformDetails,
  );

  const handleChildComponentToValidatePassword = () => {
    if (childRef.current) {
      return childRef.current.childComponetCall();
    }
    return true;
  };
  useEffect(() => {
    const fetchData = async () => {
      const authMode = props.authModeSettings;
      if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD) {
        updateAuthModeState({ password: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_OTP) {
        updateAuthModeState({ otp: true });
        updateAuthStateState({ isOtpVerificationRequired: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_AUTHAPP) {
        updateAuthModeState({ authApp: true });
        updateAuthStateState({ is2faAuthRequired: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_OR_OTP) {
        updateAuthModeState({ passwordOrOTP: true });
        updateAuthStateState({ isOtpVerificationRequired: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_OR_AUTHAPP) {
        updateAuthModeState({ passwordOrAuthApp: true });
        updateAuthStateState({ is2faAuthRequired: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_AND_OTP) {
        updateAuthModeState({ passwordAndOTP: true });
        updateAuthStateState({ isOtpVerificationRequired: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_AND_AUTHAPP) {
        updateAuthModeState({ passwordAndAuthApp: true });
        updateAuthStateState({ is2faAuthRequired: true });
      }
      updateAuthStateState({ otpSendTo: authMode?.otpMode ?? "" });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEmailChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputEmail = e.target.value;
    const localPart = inputEmail.split("@")[0];
    const isPhone = !isNaN(Number(inputEmail.slice(0, 3)));
    updateUserDetailsState({
      emailOrPhone: inputEmail,
      userName: isPhone ? "" : localPart,
    });
    // Any edit invalidates the message and the checks still in flight for the
    // previous value, otherwise a stale message stays on screen next to the new value.
    cancelPendingEmailCheck();
    updateErrorsState({
      emailOrPhoneError: false,
      emailOrPhoneErrorMessage: "",
    });
  };
  const cancelPendingEmailCheck = () => {
    clearTimeout(emailCheckTimerRef.current);
    emailCheckSeqRef.current += 1;
  };
  const handleOnBlurEmailChange = async (e: React.FocusEvent<HTMLInputElement>) => {
    const emailOrPhone = e.target.value;
    cancelPendingEmailCheck();
    if (!emailOrPhone && userDetails.emailOrPhone.length <= 1) return;
    if (!isValidEmailOrPhone(emailOrPhone)) {
      setSkipLoading(true);
      return;
    }
    setEmailLoading(true);
    const checkSeq = emailCheckSeqRef.current;
    emailCheckTimerRef.current = setTimeout(async () => {
      setSkipLoading(true);
      // An account that already exists in the portal is terminal: report it once
      // and stop, so the enterprise lookup cannot overwrite that with a
      // contradictory "does not exist" message.
      if (!(await validateEmailExistInPortal(emailOrPhone, checkSeq))) return;
      if (!(await checkUserExistInHrEmployee(emailOrPhone, checkSeq))) return;
      setSkipLoading(false);
    }, 500);
  };
  // A check is stale once a newer one has been started for a different value.
  const isStaleEmailCheck = (checkSeq?: number) =>
    checkSeq !== undefined && checkSeq !== emailCheckSeqRef.current;
  const checkUserExistInHrEmployee = async (emailOrPhone: string, checkSeq?: number) => {
    const userInfo = await executeApi<string, EnterpriseUserDto>(userExist, emailOrPhone);
    if (isStaleEmailCheck(checkSeq)) return false;
    if (!userInfo) {
      updateErrorsState({
        emailOrPhoneError: true,
        emailOrPhoneErrorMessage: USERSIGNUPMESSAGES.EMAIL_PHONE_DOES_NOT_EXIST,
      });
      setEmailLoading(false);
      return false;
    } else if (userInfo.activeRoleStatus === COMMONCONSTANTS.ROLE_NOT_ASSIGNED) {
      updateErrorsState({
        emailOrPhoneError: true,
        emailOrPhoneErrorMessage: USERSIGNUPMESSAGES.NOT_HAVE_ROLE_ASSIGNED,
      });
      setEmailLoading(false);
      return false;
    } else if (userInfo.isAlreadyRegistered) {
      // Same message as the portal duplicate check below - both mean the email is
      // already registered, so they must not word it differently.
      updateErrorsState({
        emailOrPhoneError: true,
        emailOrPhoneErrorMessage: USERSIGNUPMESSAGES.EMAIL_ALREADY_TAKEN,
      });
      setEmailLoading(false);
      return false;
    } else {
      updateErrorsState({
        emailOrPhoneError: false,
        emailOrPhoneErrorMessage: "",
      });
    }
    let cachedEmail = "";
    let cachedPhone = "";

    if (userInfo.emailAddress?.toLowerCase() === emailOrPhone) {
      cachedEmail = userInfo.emailAddress;
    } else if (userInfo.emailAddress2?.toLowerCase() === emailOrPhone) {
      cachedEmail = userInfo.emailAddress2;
    } else if (userInfo.cellPhone === emailOrPhone) {
      cachedPhone = userInfo.cellPhone;
    }
    updateUserDetailsState({
      userFirstName: userInfo.firstName,
      userLastName: userInfo.lastName,
      userPhone: userInfo.phone,
      userCellPhone: userInfo.cellPhone,
      userName: userDetails.userName,
      userEmail: userInfo.emailAddress,
      userEmail2: userInfo.emailAddress2,
      entityId: userInfo.entityId,
      userModuleName: userInfo.moduleName,
      cachedEmailAddress: cachedEmail || userInfo.emailAddress2,
      cachedCellPhone: cachedPhone || userInfo.cellPhone,
      emailSource: userInfo.emailSource,
    });
    return true;
  };

  const handleUserNameChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length === 0) {
      updateErrorsState({
        userNameError: false,
        userNameErrorMessage: "",
      });
    }
    updateUserDetailsState({ userName: event.target.value });
    validateUserNameField(event.target.value);
  };

  const handleActionFromOtp = async (source?: string) => {
    if ((authMode.passwordOrOTP || authMode.passwordOrAuthApp) && source === VERIFICATIONTYPE.OTP) {
      handleClearPasswordField();
    }
    const res = await validateUserInfo();
    if (authMode.passwordAndAuthApp || authMode.passwordAndOTP) {
      if (!(await validateAuthModePasswordAndAuthApp())) return;
    }
    return res;
  };
  const handleClearPasswordField = () => {
    if (childRef.current) {
      return childRef.current.clearPassFieldchildComponetCall();
    }
    return true;
  };
  const validateUserOrPhoneField = (emailOrPhone: string) => {
    let isValid = true;
    if (!userDetails.emailOrPhone || userDetails.emailOrPhone.trim() === "") {
      updateErrorsState({
        emailOrPhoneError: true,
        emailOrPhoneErrorMessage: USERSIGNUPMESSAGES.FILL_OUT_EMAIL_OR_PHONE,
      });
      isValid = false;
    } else {
      isValid = isValidEmailOrPhone(emailOrPhone);
    }
    return isValid;
  };
  const isValidEmailOrPhone = (emailOrPhone: string): boolean => {
    if (REGEX.EMAIL.test(emailOrPhone) || REGEX.PHONE.test(emailOrPhone)) {
      updateErrorsState({
        emailOrPhoneError: false,
        emailOrPhoneErrorMessage: "",
      });
      return true;
    } else {
      updateErrorsState({
        emailOrPhoneError: true,
        emailOrPhoneErrorMessage: USERSIGNUPMESSAGES.ENTER_VALID_EMAIL_OR_PHONE,
      });
      return false;
    }
  };
  const validateUserInfo = async () => {
    let isValidEmail = validateUserOrPhoneField(userDetails.emailOrPhone);
    let isValidUsername = validateUserNameField(userDetails.userName);
    let result = false;

    if (isValidEmail) {
      // Same order as the on-blur check (portal registration first, and terminal
      // when it matches) so one email never yields two different messages.
      isValidEmail = await validateEmailExistInPortal(userDetails.emailOrPhone);

      if (isValidEmail) {
        isValidEmail = await checkUserExistInHrEmployee(userDetails.emailOrPhone);
      }
    }

    if (isValidUsername && userDetails.userName.trim() !== "") {
      isValidUsername = await validateUserNameExistInPortal(userDetails.userName);
    }

    focusOnEmptyField();

    result = isValidEmail && isValidUsername;

    return result;
  };
  const focusOnEmptyField = () => {
    if (!userDetails.emailOrPhone) {
      emailOrPhoneRef.current?.focus();
    } else if (!userDetails.userName) {
      userNameRef.current?.focus();
    }
  };
  const validateUserNameField = (username: string) => {
    let isValid = true;
    if (!username || username.trim() === "") {
      isValid = true;
    } else if (!REGEX.USERNAME.test(username)) {
      updateErrorsState({
        userNameError: true,
        userNameErrorMessage: USERSIGNUPMESSAGES.USERNAME_CAN_ONLY_CONTAIN,
      });
      isValid = false;
    } else {
      updateErrorsState({ userNameError: false, userNameErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };
  const handleOnBlurUserNameExist = async (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value.trim() !== "" && !errors.emailOrPhoneError) {
      if (e.target.value.length > 0) {
        setUserNameLoading(true);
        setTimeout(async () => {
          await validateUserNameExistInPortal(e.target.value);
          setUserNameLoading(false);
        }, 500);
      } else {
        validateUserNameField(e.target.value);
      }
    }
  };
  const validateEmailExistInPortal = async (useName: string, checkSeq?: number) => {
    let isValid = true;
    const isUserNameExist = await executeApi<string, boolean>(checkEmailOrPhoneExist, useName);
    if (isStaleEmailCheck(checkSeq)) return false;
    if (isUserNameExist) {
      updateErrorsState({
        emailOrPhoneError: true,
        emailOrPhoneErrorMessage: USERSIGNUPMESSAGES.EMAIL_ALREADY_TAKEN,
      });
      isValid = false;
    } else {
      updateErrorsState({
        emailOrPhoneError: false,
        emailOrPhoneErrorMessage: "",
      });
      isValid = true;
    }
    setEmailLoading(false);
    return isValid;
  };
  const validateUserNameExistInPortal = async (useName: string) => {
    let isValid = true;
    if (useName.trim() !== "") {
      const isUserNameExist = await executeApi<string, boolean>(checkUsernameExist, useName);
      if (isUserNameExist) {
        updateErrorsState({
          userNameError: true,
          userNameErrorMessage: USERSIGNUPMESSAGES.USERNAME_ALREADY_TAKEN,
        });
        isValid = false;
      } else if (!REGEX.USERNAME.test(useName)) {
        updateErrorsState({
          userNameError: true,
          userNameErrorMessage: USERSIGNUPMESSAGES.USERNAME_CAN_ONLY_CONTAIN,
        });
        isValid = false;
      } else {
        updateErrorsState({ userNameError: false, userNameErrorMessage: "" });
        isValid = true;
      }
    }
    return isValid;
  };

  const handlePasswordChange = (newPassword: string) => {
    updateUserDetailsState({ password: newPassword });
  };
  const handleConfirmPasswordChange = (confirmPassword: string) => {
    updateUserDetailsState({ confirmPassword: confirmPassword });
  };
  const handleCreateAccount = async (secretKey?: string) => {
    if (!(await validateUserInfo())) return;
    const userData: UserDto = {
      userName: userDetails.userName,
      cachedEmailAddress: userDetails.cachedEmailAddress,
      cachedPhoneNumber: userDetails.cachedCellPhone,
      firstName: userDetails.userFirstName,
      lastName: userDetails.userLastName,
      module: userDetails.userModuleName,
      entityId: userDetails.entityId,
      emailSource: userDetails.emailSource,
    };
    let validationError = "";

    if (authMode.password) {
      if (!handleChildComponentToValidatePassword()) return;
      validationError = "";
      userData.password = userDetails.password;
    } else if (authMode.authApp) {
      userData.secretKey = secretKey;
      userData.mode = OTPMODE.TWOFA;
    } else if (authMode.passwordOrOTP) {
      userData.password = userDetails.password;
    } else if (authMode.passwordOrAuthApp) {
      userData.secretKey = secretKey;
      userData.password = userDetails.password;
      userData.mode = OTPMODE.TWOFA;
    } else if (authMode.passwordAndOTP) {
      userData.password = userDetails.password;
    } else if (authMode.passwordAndAuthApp) {
      userData.secretKey = secretKey;
      userData.mode = OTPMODE.TWOFA;
      userData.password = userDetails.password;
    }

    if (validationError) {
      updateErrorsState({ validationMessage: validationError });
      return;
    }
    const result = await executeApi<UserDto, UserResponseDto>(createUser, userData);
    if (result.userId > 0 && result.responseMessage === COMMONCONSTANTS.ROLE_MAPPED) {
      onSuccessMsg();
      onSetCookiesAndRedirectToSignInTab();
    } else if (
      result.userId > 0 &&
      (result.responseMessage === COMMONCONSTANTS.ROLE_NOT_MAPPED ||
        result.responseMessage === COMMONCONSTANTS.ROLE_NOT_FOUND)
    ) {
      onSuccessMsg();
      onSetCookiesAndRedirectToSignInTab();
    }
  };
  const onSuccessMsg = () => {
    setSnackbarOpen(true);
  };
  const onSetCookiesAndRedirectToSignInTab = () => {
    const oneMinuteFromNow = new Date(new Date().getTime() + 1 * 60 * 1000);
    Cookies.set(COOKIESNAME.USERSIGNUPINPUT, userDetails.emailOrPhone, {
      expires: oneMinuteFromNow,
      secure: true,
      sameSite: "Strict",
    });
    setTimeout(async () => {
      props.onTabClick?.(0);
    }, 2000);
  };

  const validateAuthModePasswordAndAuthApp = async () => {
    if (!(await validateUserInfo()) || !handleChildComponentToValidatePassword()) {
      return;
    } else {
      updateErrorsState({ validationMessage: "" });
    }
    return true;
  };
  const handleIsOtpVerified = (otp: string, isOtpMatched: boolean, secretKey?: string) => {
    handleCreateAccount(secretKey);
  };
  const handleIsSessionLocked = () => {
    setIsSessionLocked(true);
    props.onIsSessionLocked();
  };

  const handleVerificationCodeComplete = (
    verificationCode: string,
    isVerificationCodeVerified: boolean,
  ) => {
    updateAuthStateState({
      token: verificationCode,
      isVerificationCodeVerified: isVerificationCodeVerified,
    });
    if (
      isVerificationCodeVerified &&
      (authMode.passwordOrAuthApp || authMode.passwordAndAuthApp || authMode.authApp)
    ) {
      onSuccessMsg();
      setTimeout(async () => {
        props.onTabClick?.(0);
      }, 2000);
    }
  };
  const handleDoNotSetOne = (event) => {
    event.preventDefault();
    updateUserDetailsState({ userName: "" });
    updateErrorsState({ userNameError: false, userNameErrorMessage: "" });
    userNameRef.current?.focus();
  };
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleFormRequestEmailChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputEmail = e.target.value;
    updateRequestFormDetailsState({
      emailOrPhone: inputEmail,
    });
    validateRequestFormEMailOrPhoneField(e.target.value);
  };

  const handleFormRequestIssueChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputIssue = e.target.value;
    updateRequestFormDetailsState({
      issueType: inputIssue,
    });
    validateIssueTypeField(e.target.value);
    // Switching to an issue type that does not require Additional Details must drop any error
    // raised for the previous type. Switching to one that does require it is not flagged until
    // the user edits the field or submits.
    if (!isAdditionalDetailsRequired(inputIssue)) {
      updateErrorsState({
        requestFormAdditionalDetailsError: false,
        requestFormAdditionalDetailsErrorMessage: "",
      });
    }
  };

  const handleRequestFormFirstNameChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    updateRequestFormDetailsState({ userFirstName: event.target.value });
    validateRequestFormFirstNameField(event.target.value);
  };

  const handleRequestFormAdditionalDetailsChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    updateRequestFormDetailsState({ additionalDetails: event.target.value });
    validateAdditionalDetailsField(event.target.value, helpdeskrequestformDetails.issueType);
  };

  // Bug 77552: Additional Details is mandatory only for the General Question issue type;
  // for Signing Up / Logging In it stays optional.
  const isAdditionalDetailsRequired = (issueType: string) =>
    issueType === COMMONCONSTANTS.ISSUE_TYPE_GENERAL_QUESTION;

  const validateAdditionalDetailsField = (additionalDetails: string, issueType: string) => {
    let isValid = true;
    if (isAdditionalDetailsRequired(issueType) && (!additionalDetails || additionalDetails.trim() === "")) {
      updateErrorsState({
        requestFormAdditionalDetailsError: true,
        requestFormAdditionalDetailsErrorMessage: USERSIGNUPMESSAGES.ISSUE_DESCRIPTION_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({
        requestFormAdditionalDetailsError: false,
        requestFormAdditionalDetailsErrorMessage: "",
      });
      isValid = true;
    }
    return isValid;
  };

  const handleRequestFormLastNameChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    updateRequestFormDetailsState({ userLastName: event.target.value });
    validateRequestFormLastNameField(event.target.value);
  };

  // Bug 77547: the Help Desk Request Form takes a single contact field - the user may have an
  // Email, a Phone, or both - so either format is accepted here, matching the Sign Up page's own
  // Email/Phone field.
  const validateRequestFormEMailOrPhoneField = (emailOrPhone: string) => {
    let isValid = true;
    if (!emailOrPhone || emailOrPhone.trim() === "") {
      updateErrorsState({
        requestFormemailOrPhoneError: true,
        requestFormemailOrPhoneErrorMessage: USERSIGNUPMESSAGES.FILL_OUT_EMAIL_PHONE,
      });
      isValid = false;
    } else if (REGEX.EMAIL.test(emailOrPhone) || REGEX.PHONE.test(emailOrPhone)) {
      updateErrorsState({
        requestFormemailOrPhoneError: false,
        requestFormemailOrPhoneErrorMessage: "",
      });
      isValid = true;
    } else {
      updateErrorsState({
        requestFormemailOrPhoneError: true,
        requestFormemailOrPhoneErrorMessage: USERSIGNUPMESSAGES.ENTER_VALID_EMAIL_OR_PHONE,
      });
      isValid = false;
    }
    return isValid;
  };

  const validatehelpdeskrequestformDetails = async () => {
    let isFirstNameValid = true;
    let isLastNameValid = true;
    let isEmailValid = true;
    let isIssueTypeValid = true;
    let isAdditionalDetailsValid = true;
    isFirstNameValid = validateRequestFormFirstNameField(helpdeskrequestformDetails.userFirstName);
    isLastNameValid = validateRequestFormLastNameField(helpdeskrequestformDetails.userLastName);
    isEmailValid = validateRequestFormEMailOrPhoneField(helpdeskrequestformDetails.emailOrPhone);
    isIssueTypeValid = validateIssueTypeField(helpdeskrequestformDetails.issueType);
    isAdditionalDetailsValid = validateAdditionalDetailsField(
      helpdeskrequestformDetails.additionalDetails,
      helpdeskrequestformDetails.issueType,
    );
    focusOnRequestFromEmptyField();
    return (
      isFirstNameValid &&
      isLastNameValid &&
      isEmailValid &&
      isIssueTypeValid &&
      isAdditionalDetailsValid
    );
  };

  const focusOnRequestFromEmptyField = () => {
    if (!helpdeskrequestformDetails.userFirstName) {
      RequestFormFirstNameRef.current?.focus();
    } else if (!helpdeskrequestformDetails.userLastName) {
      RequestFormLastNameRef.current?.focus();
    } else if (!helpdeskrequestformDetails.emailOrPhone) {
      emailOrPhoneRef.current?.focus();
    } else if (
      isAdditionalDetailsRequired(helpdeskrequestformDetails.issueType) &&
      !helpdeskrequestformDetails.additionalDetails?.trim()
    ) {
      additionalDetailsRef.current?.focus();
    }
  };

  const validateRequestFormFirstNameField = (firstname: string) => {
    let isValid = true;
    if (!firstname || firstname.trim() === "") {
      updateErrorsState({
        requestFormFirstNameError: true,
        requestFormFirstNameErrorMessage: USERSIGNUPMESSAGES.USERFIRSTNAME_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({ requestFormFirstNameError: false, requestFormFirstNameErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };

  const validateIssueTypeField = (issueType: string) => {
    let isValid = true;
    if (!issueType) {
      updateErrorsState({
        requestFormIssueTypeError: true,
        requestFormIssueTypeErrorMessage: USERSIGNUPMESSAGES.IssueType_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({ requestFormIssueTypeError: false, requestFormIssueTypeErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };

  const validateRequestFormLastNameField = (lastname: string) => {
    let isValid = true;
    if (!lastname || lastname.trim() === "") {
      updateErrorsState({
        requestFormLastNameError: true,
        requestFormLastNameErrorMessage: USERSIGNUPMESSAGES.USERLASTNAME_IS_REQUIRED,
      });
      isValid = false;
    } else {
      updateErrorsState({ requestFormLastNameError: false, requestFormLastNameErrorMessage: "" });
      isValid = true;
    }
    return isValid;
  };

  const handleRequestFormSend = async () => {
    if (!(await validatehelpdeskrequestformDetails())) return;
    const enteredEmailOrPhone = helpdeskrequestformDetails.emailOrPhone.trim();
    const isMail = REGEX.EMAIL.test(enteredEmailOrPhone);
    // Bug 77547: the single field carries either an Email or a Phone, so report it to HR under the
    // matching heading. A phone is resolved to the registered user's email where one exists, so HR
    // can still reply; otherwise only the phone goes out.
    let email = isMail ? enteredEmailOrPhone : "";
    const phone = isMail ? "" : enteredEmailOrPhone;
    let isReplyToMe = false;
    if (!isMail) {
      const userDetails = await executeApi<string, EnterpriseUserDto>(
        userExist,
        enteredEmailOrPhone,
      );
      if (userDetails?.emailAddress) {
        email = userDetails.emailAddress;
        isReplyToMe = true;
      }
    } else {
      isReplyToMe = true;
    }
    const portalRequestFormDetailsDto: PortalRequestFormDetailsDto = {
      userName:
        helpdeskrequestformDetails.userFirstName + " " + helpdeskrequestformDetails.userLastName,
      email: email,
      phone: phone,
      firstName: helpdeskrequestformDetails.userFirstName,
      lastName: helpdeskrequestformDetails.userLastName,
      issueName: helpdeskrequestformDetails.issueType,
      additionalDetails: helpdeskrequestformDetails.additionalDetails,
      moduleName: COMMONCONSTANTS.MODULENAME,
      isReplyToMe: isReplyToMe,
    };
    const issueType = await executeApi<PortalRequestFormDetailsDto, boolean>(
      sendHelpDeskRequestForm,
      portalRequestFormDetailsDto,
    );
    if (issueType) {
      setrequestFormSnackbarOpen(true);
      sethelpdeskrequestformDetails({
        additionalDetails: "",
        emailOrPhone: "",
        issueType: "",
        userEmail: "",
        userFirstName: "",
        userLastName: "",
        userName: "",
      });
      handleDialogClose();
      setTimeout(() => {
        setrequestFormSnackbarOpen(false);
      }, 3000);
    } else {
      setrequestFormSnackbarOpen(false);
    }
  };

  const handleRequestFormSnackbarClose = () => setrequestFormSnackbarOpen(false);

  // PopOver
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const popperRef = useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (popperRef.current && !popperRef.current.contains(event.target as Node)) {
      setAnchorEl(null);
    }
  };

  const handleClickOutsideHover = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (anchorEl) {
      document.addEventListener(COMMONCONSTANTS.MOUSEDOWN, handleClickOutside);
    } else {
      document.removeEventListener(COMMONCONSTANTS.MOUSEDOWN, handleClickOutside);
    }
    return () => {
      document.removeEventListener(COMMONCONSTANTS.MOUSEDOWN, handleClickOutside);
    };
  }, [anchorEl]);

  const open = Boolean(anchorEl);
  const id = open ? COMMONCONSTANTS.SIMPLEPOPOVER : undefined;
  const [dialogopen, setOpen] = React.useState(false);
  const handleDialogClickOpen = () => {
    updateValue({ issueTypeOptions: props.issueType });
    updateRequestFormDetailsState({ additionalDetails: "" });
    updateErrorsState({ requestFormFirstNameError: false, requestFormFirstNameErrorMessage: "" });
    updateErrorsState({ requestFormLastNameError: false, requestFormLastNameErrorMessage: "" });
    updateErrorsState({
      requestFormemailOrPhoneError: false,
      requestFormemailOrPhoneErrorMessage: "",
    });
    updateErrorsState({
      requestFormAdditionalDetailsError: false,
      requestFormAdditionalDetailsErrorMessage: "",
    });
    setOpen(true);
  };
  const handleDialogClose = () => {
    setOpen(false);
  };
  const handleLoginClick = (event) => {
    event.preventDefault();
    props.onTabClick?.(0);
  };
  return (
    <div className="sign-up ">
      <input type="hidden" id="hdnAuthMode" value={props.authModeSettings.signUpMode} />
      {isSessionLocked && (
        <Alert severity="error" sx={{ marginBottom: "10px" }} className="alert-alert">
          {USERSIGNINMESSAGES.SESSION_LOCKED_MESSAGE.replace(
            "{Session_value}",
            localStorage.getItem(USERINFO.SESSIONVALUE),
          )}
          <Typography variant="body2" marginTop={2}>
            {COMMONCONSTANTS.FURTHERQUERY}
          </Typography>

          <Typography variant="body2">
            <Link component="button" variant="body2" onClick={handleDialogClickOpen}>
              {COMMONCONSTANTS.CLICKHERE}
            </Link>
            {COMMONCONSTANTS.FILLOUTFORM}
          </Typography>
        </Alert>
      )}
      <div className={isSessionLocked ? "disabled-div" : ""}>
        <Typography component="h1" variant="h4" className="typography-signup">
          {SIGNUPMODE.SIGNUP_PAGE_TITLE}{" "}
          <div className="popper-wrapper">
            <Tooltip title={POPOVERMESSAGES.HelpTooltip} arrow placement="top">
              <IconButton
                id="SignUpHelpOutIcon"
                tabIndex={-1}
                aria-describedby={id}
                onClick={handleClick}
                sx={{ color: "#333333" }} // Apply custom icon color
              >
                {<HelpOutline sx={{ fontSize: "18px", fill: "#333333a6" }} />}
              </IconButton>
            </Tooltip>
            {/* Popover */}
            <Popper id={id} open={open} anchorEl={anchorEl} ref={popperRef} sx={{ zIndex: 1 }}>
              <Paper
                sx={{
                  position: "relative",
                  p: 2,
                  boxShadow: 3,
                  zIndex: 1,
                }}
              >
                {/* Arrow */}
                <div className="arrow" />
                <Typography variant="h1" component="h1" className="mb-3">
                  {COMMONCONSTANTS.SIGNINGWORKS}
                </Typography>
                <Typography
                  variant="body2"
                  component="p"
                  dangerouslySetInnerHTML={{ __html: POPOVERMESSAGES.SIGNUP }}
                ></Typography>
                <Typography variant="body2" marginTop={2}>
                  {COMMONCONSTANTS.FURTHERQUERY}
                </Typography>

                <Typography variant="body2">
                  <Link
                    component="button"
                    variant="body2"
                    onClick={handleDialogClickOpen}
                    id="clickHereTypography"
                  >
                    {COMMONCONSTANTS.CLICKHERE}
                  </Link>
                  {COMMONCONSTANTS.FILLOUTFORM}
                </Typography>
                <div>
                  {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
                  <button onClick={handleClickOutsideHover} autoFocus className="button">
                    {COMMONCONSTANTS.GOTIT}
                  </button>
                </div>
              </Paper>
            </Popper>
            <Dialog
              onClose={handleDialogClose}
              aria-labelledby="customized-dialog-title"
              open={dialogopen}
              slotProps={{
                paper: {
                  className: "helpdesk-custom-dialog",
                },
              }}
            >
              <DialogTitle className="helpdesk-dialog-title">
                <img src="/logo.svg" alt="logo" className="request-form-logo" />
                <IconButton
                  aria-label="close"
                  onClick={handleDialogClose}
                  className="dialog-close-button"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Typography align="center" variant="h1" color="primary">
                  {COMMONCONSTANTS.HELPFORM}
                </Typography>

                <FormControl fullWidth>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      bgcolor: "background.paper",
                      gap: 5,
                      padding: "0px",
                      border: "2px",
                      marginTop: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    <TextField
                      required
                      fullWidth
                      id="firstName"
                      name="firstName"
                      autoComplete="name"
                      variant="outlined"
                      label={COMMONCONSTANTS.FIRSTNAMEPLACEHOLDER}
                      // eslint-disable-next-line jsx-a11y/no-autofocus
                      autoFocus
                      value={helpdeskrequestformDetails.userFirstName}
                      onChange={handleRequestFormFirstNameChange}
                      error={errors.requestFormFirstNameError}
                      helperText={errors.requestFormFirstNameErrorMessage}
                      color={errors.requestFormFirstNameError ? "error" : "primary"}
                      inputRef={RequestFormFirstNameRef}
                      size="small"
                      sx={{ mt: 0.5 }}
                      InputProps={{
                        endAdornment: helpdeskrequestformDetails.userFirstName && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => updateRequestFormDetailsState({ userFirstName: "" })}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <TextField
                      required
                      fullWidth
                      id="lastName"
                      label={COMMONCONSTANTS.LASTNAMEPLACEHOLDER}
                      name="lastName"
                      autoComplete="name"
                      variant="outlined"
                      value={helpdeskrequestformDetails.userLastName}
                      onChange={handleRequestFormLastNameChange}
                      error={errors.requestFormLastNameError}
                      helperText={errors.requestFormLastNameErrorMessage}
                      color={errors.requestFormLastNameError ? "error" : "primary"}
                      inputRef={RequestFormLastNameRef}
                      size="small"
                      sx={{ mt: 0.5 }}
                      InputProps={{
                        endAdornment: helpdeskrequestformDetails.userLastName && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => updateRequestFormDetailsState({ userLastName: "" })}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </FormControl>
                <Box
                  component="form"
                  noValidate
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: 2,
                    padding: "0px",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      required
                      fullWidth
                      id="requestFormEmailOrPhone"
                      label={COMMONCONSTANTS.EMAILORPHONEPLACEHOLDER}
                      name="requestFormEmailOrPhone"
                      autoComplete="email"
                      variant="outlined"
                      value={helpdeskrequestformDetails.emailOrPhone}
                      onChange={handleFormRequestEmailChange}
                      error={errors.requestFormemailOrPhoneError}
                      helperText={errors.requestFormemailOrPhoneErrorMessage}
                      color={errors.requestFormemailOrPhoneError ? "error" : "primary"}
                      inputRef={emailOrPhoneRef}
                      size="small"
                      sx={{ mt: 0.5 }}
                      InputProps={{
                        endAdornment: helpdeskrequestformDetails.emailOrPhone && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => updateRequestFormDetailsState({ emailOrPhone: "" })}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mt: "3px" }} size="small" required>
                    <InputLabel id="demo-simple-select-label">{COMMONCONSTANTS.ISSUE}</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      required
                      fullWidth
                      label={COMMONCONSTANTS.ISSUE}
                      id="formRequestIssue"
                      name="formRequestIssue"
                      variant="outlined"
                      value={helpdeskrequestformDetails.issueType}
                      onChange={handleFormRequestIssueChange}
                      error={errors.requestFormIssueTypeError}
                      color={errors.requestFormIssueTypeError ? "error" : "primary"}
                      size="small"
                    >
                      {state.issueTypeOptions.map((item) => (
                        <MenuItem key={item.issueTypeId} value={item.issueType}>
                          {item.issueType}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText error>{errors.requestFormIssueTypeErrorMessage}</FormHelperText>
                  </FormControl>
                  <FormControl fullWidth sx={{ mt: "5px" }}>
                    <TextField
                      required={isAdditionalDetailsRequired(helpdeskrequestformDetails.issueType)}
                      fullWidth
                      id="additionalDetails"
                      label={COMMONCONSTANTS.ADDITIONALDETAILSPLACEHOLDER}
                      name="additionalDetails"
                      autoComplete="Details"
                      variant="outlined"
                      multiline
                      rows={4}
                      value={helpdeskrequestformDetails.additionalDetails}
                      size="small"
                      onChange={handleRequestFormAdditionalDetailsChange}
                      error={errors.requestFormAdditionalDetailsError}
                      helperText={errors.requestFormAdditionalDetailsErrorMessage}
                      color={errors.requestFormAdditionalDetailsError ? "error" : "primary"}
                      inputRef={additionalDetailsRef}
                      sx={{ mt: 0.5 }}
                    />
                  </FormControl>
                </Box>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus
                  id="helpformsend"
                  variant="contained"
                  sx={{ mt: 1, mb: 1 }}
                  onClick={handleRequestFormSend}
                >
                  {COMMONCONSTANTS.SEND}
                </Button>
              </DialogActions>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: "13px", marginLeft: "15px", mb: 2, color: "black" }}
              >
                {USERSIGNUPMESSAGES.INSTRUCTIONTEXT}
              </Typography>
            </Dialog>
          </div>
        </Typography>

        <Box
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "0px",
            border: "2px",
          }}
        >
          <Paper variant="outlined" className="paper">
            <Box component="form" className="signup-box">
              <FormControl fullWidth>
                <TextField
                  required
                  fullWidth
                  id="emailOrPhone"
                  label="Email or Phone"
                  name="emailOrPhone"
                  autoComplete="email"
                  variant="outlined"
                  value={userDetails.emailOrPhone}
                  onChange={handleEmailChange}
                  onBlur={handleOnBlurEmailChange}
                  error={errors.emailOrPhoneError}
                  helperText={errors.emailOrPhoneErrorMessage}
                  color={errors.emailOrPhoneError ? "error" : "primary"}
                  inputRef={emailOrPhoneRef}
                  size="small"
                  autoFocus
                  InputProps={{
                    endAdornment: emailLoading ? (
                      <InputAdornment position="end">
                        <img src="/loading-logo.gif" alt="loading" className="input-loader" />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  autoComplete="name"
                  name="userName"
                  fullWidth
                  id="userName"
                  label="Username"
                  value={userDetails.userName}
                  onChange={handleUserNameChange}
                  onBlur={handleOnBlurUserNameExist}
                  error={errors.userNameError}
                  helperText={errors.userNameErrorMessage}
                  color={errors.userNameError ? "error" : "primary"}
                  inputRef={userNameRef}
                  size="small"
                  InputProps={{
                    endAdornment: userNameLoading ? (
                      <InputAdornment position="end">
                        <img src="/loading-logo.gif" alt="loading" className="input-loader" />
                      </InputAdornment>
                    ) : null,
                  }}
                />

                <div className="div-popover-do-not-set-one">
                  <Link
                    component="button"
                    onClick={handleDoNotSetOne}
                    variant="body2"
                    className="link-do-not-set-one"
                  >
                    Do not set one
                  </Link>
                  <Tooltip title={POPOVERMESSAGES.HelpTooltip} arrow placement="top">
                    <div className="popover-do-not-set-one">
                      <PopoverWithArrow
                        icon={<HelpOutline sx={{ fontSize: "18px", fill: "#333333a6" }} />}
                        htmlContent="<h6>Why do I need a Username?</h6><p>You don't need one, but it will be easier to type just a Username as opposed to your full email address or cellphone number every time.</p>"
                        placement="top"
                        iconColor="#333333"
                        hideButton={false}
                        buttonText={COMMONCONSTANTS.GOTIT}
                      />
                    </div>
                  </Tooltip>
                </div>
              </FormControl>
            </Box>
          </Paper>
          <BackdropProgressBar loading={loading && !skipLoading} />
          {authMode.password && (
            <>
              <Paper variant="outlined" className="paper">
                <SignUpWithPassword
                  ref={childRef}
                  onPasswordInputChange={handlePasswordChange}
                  onConfirmPasswordInputChange={handleConfirmPasswordChange}
                  userFirstName={userDetails.userFirstName}
                  userLastName={userDetails.userLastName}
                  userName={userDetails.userName}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  otpSendTo={authState.otpSendTo}
                  onOtpVerified={handleIsOtpVerified}
                  authMode=""
                  onIsSessionLocked={handleIsSessionLocked}
                  onParentAction={handleActionFromOtp}
                ></SignUpWithPassword>
              </Paper>
            </>
          )}
          {authMode.otp && (
            <>
              <Paper variant="outlined" className="paper">
                <SignUpWithOTP
                  onOtpVerified={handleIsOtpVerified}
                  onParentAction={handleActionFromOtp}
                  headerText={""}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  userName={userDetails.userName}
                  otpSendTo={authState.otpSendTo}
                  onIsSessionLocked={handleIsSessionLocked}
                />
              </Paper>
            </>
          )}
          {authMode.authApp && (
            <>
              <Paper variant="outlined" className="paper">
                <div>
                  <Box>
                    <>
                      <SignUpWithTwoFactorAuth
                        onParentAction={handleActionFromOtp}
                        onVerificationCodeComplete={handleVerificationCodeComplete}
                        headerText={""}
                        email={userDetails.cachedEmailAddress}
                        phone={userDetails.userCellPhone}
                        userName={userDetails.userName}
                        otpSendTo={authState.otpSendTo}
                        onOtpVerified={handleIsOtpVerified}
                        onIsSessionLocked={handleIsSessionLocked}
                      ></SignUpWithTwoFactorAuth>
                    </>
                  </Box>
                </div>
              </Paper>
            </>
          )}
          {authMode.passwordOrOTP && (
            <>
              <Paper variant="outlined" className="paper">
                <SignUpWithPassword
                  ref={childRef}
                  onPasswordInputChange={handlePasswordChange}
                  onConfirmPasswordInputChange={handleConfirmPasswordChange}
                  userFirstName={userDetails.userFirstName}
                  userLastName={userDetails.userLastName}
                  userName={userDetails.userName}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  otpSendTo={authState.otpSendTo}
                  onOtpVerified={handleIsOtpVerified}
                  authMode=""
                  onIsSessionLocked={handleIsSessionLocked}
                  onParentAction={handleActionFromOtp}
                ></SignUpWithPassword>
              </Paper>
              <Divider className="sign-in-divider">or</Divider>
              <Paper variant="outlined" className="paper">
                <SignUpWithOTP
                  onOtpVerified={handleIsOtpVerified}
                  onParentAction={handleActionFromOtp}
                  headerText={""}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  userName={userDetails.userName}
                  otpSendTo={authState.otpSendTo}
                  onIsSessionLocked={handleIsSessionLocked}
                />
              </Paper>
            </>
          )}
          {authMode.passwordOrAuthApp && (
            <>
              <Paper variant="outlined" className="paper">
                <SignUpWithPassword
                  ref={childRef}
                  onPasswordInputChange={handlePasswordChange}
                  onConfirmPasswordInputChange={handleConfirmPasswordChange}
                  userFirstName={userDetails.userFirstName}
                  userLastName={userDetails.userLastName}
                  userName={userDetails.userName}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  otpSendTo={authState.otpSendTo}
                  onOtpVerified={handleIsOtpVerified}
                  authMode=""
                  onIsSessionLocked={handleIsSessionLocked}
                  onParentAction={handleActionFromOtp}
                ></SignUpWithPassword>
              </Paper>
              <Divider className="sign-in-divider">or</Divider>
              <Paper variant="outlined" className="paper">
                <SignUpWithTwoFactorAuth
                  onParentAction={handleActionFromOtp}
                  onVerificationCodeComplete={handleVerificationCodeComplete}
                  headerText={""}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  userName={userDetails.userName}
                  otpSendTo={authState.otpSendTo}
                  onOtpVerified={handleIsOtpVerified}
                  onIsSessionLocked={handleIsSessionLocked}
                ></SignUpWithTwoFactorAuth>
              </Paper>
            </>
          )}
          {authMode.passwordAndOTP && (
            <>
              <Paper variant="outlined" className="paper">
                <SignUpWithPassword
                  ref={childRef}
                  onPasswordInputChange={handlePasswordChange}
                  onConfirmPasswordInputChange={handleConfirmPasswordChange}
                  userFirstName={userDetails.userFirstName}
                  userLastName={userDetails.userLastName}
                  userName={userDetails.userName}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  otpSendTo={authState.otpSendTo}
                  onOtpVerified={handleIsOtpVerified}
                  authMode={SIGNUPMODE.SIGNUP_WITH_PASSWORD_AND_OTP}
                  onIsSessionLocked={handleIsSessionLocked}
                  onParentAction={handleActionFromOtp}
                ></SignUpWithPassword>
                <div className="margin-top"></div>
                <SignUpWithOTP
                  onOtpVerified={handleIsOtpVerified}
                  onParentAction={handleActionFromOtp}
                  headerText={"And"}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  userName={userDetails.userName}
                  otpSendTo={authState.otpSendTo}
                  onIsSessionLocked={handleIsSessionLocked}
                />
              </Paper>
            </>
          )}
          {authMode.passwordAndAuthApp && (
            <>
              <Paper variant="outlined" className="paper">
                <SignUpWithPassword
                  ref={childRef}
                  onPasswordInputChange={handlePasswordChange}
                  onConfirmPasswordInputChange={handleConfirmPasswordChange}
                  userFirstName={userDetails.userFirstName}
                  userLastName={userDetails.userLastName}
                  userName={userDetails.userName}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  otpSendTo={authState.otpSendTo}
                  onOtpVerified={handleIsOtpVerified}
                  authMode={SIGNUPMODE.SIGNUP_WITH_PASSWORD_AND_AUTHAPP}
                  onIsSessionLocked={handleIsSessionLocked}
                  onParentAction={handleActionFromOtp}
                ></SignUpWithPassword>
                <div className="margin-top"></div>
                <SignUpWithTwoFactorAuth
                  onParentAction={handleActionFromOtp}
                  onVerificationCodeComplete={handleVerificationCodeComplete}
                  headerText={"And"}
                  email={userDetails.cachedEmailAddress}
                  phone={userDetails.userCellPhone}
                  userName={userDetails.userName}
                  otpSendTo={authState.otpSendTo}
                  onOtpVerified={handleIsOtpVerified}
                  onIsSessionLocked={handleIsSessionLocked}
                ></SignUpWithTwoFactorAuth>
              </Paper>
            </>
          )}
          <p className="center-text-red">{errors.validationMessage}</p>
          <Typography sx={{ textAlign: "center", fontSize: "14px" }}>
            Already have an account?{" "}
            <Link
              href="/signin"
              onClick={handleLoginClick}
              variant="body2"
              sx={{ alignSelf: "center" }}
            >
              Login
            </Link>
          </Typography>
          <EmployeeCheck isSignin={false} />
        </Box>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={15000}
          onClose={handleSnackbarClose}
        >
          <Alert onClose={handleSnackbarClose} severity="success">
            {USERSIGNUPMESSAGES.SAVE_AND_ROLE_MESSAGE}
          </Alert>
        </Snackbar>
      </div>
      <Snackbar
        open={requestFormSnackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={handleRequestFormSnackbarClose}
      >
        <Alert onClose={handleRequestFormSnackbarClose} severity="success">
          {USERSIGNUPMESSAGES.REQUESTFORMSUCCESSMESSAGE}
        </Alert>
      </Snackbar>
    </div>
  );
}
